<template>
  <section
    class="py-12 sm:py-16 md:py-20 lg:py-24 xl:py-32 bg-gradient-to-r from-[#0b105d] to-[#fe6d0d]"
  >
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 text-center">
      <h2
        class="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-4 sm:mb-6"
        data-aos="zoom-in"
      >
        {{ $t('hero.subtitle') }}
      </h2>
      <p
        class="text-base sm:text-lg text-[#f4f4f4] opacity-90 max-w-xl sm:max-w-2xl mx-auto mb-8 sm:mb-10"
        data-aos="zoom-in"
        data-aos-delay="100"
      >
        {{ $t('torukMagic.description') }}
      </p>
      <router-link
        to="/contact"
        class="group relative inline-flex items-center gap-2 px-8 sm:px-10 py-3 sm:py-4 bg-white text-[#0b105d] font-bold rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 overflow-hidden text-base sm:text-lg"
        data-aos="zoom-in"
        data-aos-delay="200"
      >
        <span class="relative z-10">{{ $t('common.contactSales') }}</span>
        <svg
          class="w-4 h-4 sm:w-5 sm:h-5 transform group-hover:translate-x-1 transition-transform"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13 7l5 5m0 0l-5 5m5-5H6"
          ></path>
        </svg>
        <div
          class="absolute inset-0 bg-gradient-to-r from-[#ffb47c]/30 to-[#fe6d0d]/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        ></div>
      </router-link>
    </div>
  </section>
</template>

<script setup lang="ts"></script>
